import cx from "classnames";
import React from "react";
import { useSelector } from "react-redux";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";
import { BasicButton, ButtonType } from "@gaming/xds-react-js";

import { ClipboardTextBox } from "../../../components";
import { ExternalLinkIcon } from "../../../components/icons";
import { partnerCenterUrl } from "../../../constants";
import { useProgramBackgroundColorPicker } from "../../../helpers/useProgramColorPicker";
import { useStrings } from "../../../localization/localizationHelpers";
import { getPartnerCenterToken, getSellerID } from "../../../redux/selectors";
import { OnboardingPageAction } from "../../../telemetry/models";
import { logPageAction } from "../../../telemetry/pageAction";
import * as styles from "./WelcomePartnerSection.module.css";

export const TokenAndStudioIds = () => {
  const [
    welcomePartnerPageFiveByFiveTitle,
    welcomePartnerPageStudioIdTitle,
    welcomePartnerPageAppDeveloperProgramGoToPartnerCenterButton,
  ] = useStrings(
    "welcomePartnerPageFiveByFiveTitle",
    "welcomePartnerPageStudioIdTitle",
    "welcomePartnerPageAppDeveloperProgramGoToPartnerCenterButton"
  );
  const partnerCenterToken = useSelector(getPartnerCenterToken);
  const sellerID = useSelector(getSellerID);
  const backgroundColorStyle = useProgramBackgroundColorPicker(true);

  const handleGoToPartnerCenter = () => {
    logPageAction(OnboardingPageAction.PartnerCenterGoToMicrosoftPartnerCenterButton);
    window.open(partnerCenterUrl, "_blank");
  };

  return (
    <Row className={styles.studioFiveByFiveRowOnWelcomePartnerCenter}>
      <Column className={styles.studioFiveByFiveContainerColumn}>
        {partnerCenterToken && (
          <ClipboardTextBox
            title={welcomePartnerPageFiveByFiveTitle}
            labelText={partnerCenterToken}
          />
        )}
        {sellerID && (
          <ClipboardTextBox title={welcomePartnerPageStudioIdTitle} labelText={sellerID} />
        )}
        <BasicButton
          as={"button"}
          buttonType={ButtonType.Brand}
          className={cx(styles.buttonGoToPartnerCenter, backgroundColorStyle)}
          onClick={() => handleGoToPartnerCenter()}
          role="link"
        >
          <ExternalLinkIcon ignoreProgramColor={true} />
          {welcomePartnerPageAppDeveloperProgramGoToPartnerCenterButton}
        </BasicButton>
      </Column>
    </Row>
  );
};
